import { GraphQLObjectType } from 'graphql'
import { viewer } from './queries/viewer'
import { organization } from './queries/organization'
import { application } from './queries/application'
import { applications } from './queries/applications'
import { applicationGrade } from './queries/application-grade'
import { applicationModules } from './queries/application-modules'
import { applicationQuickFilters } from './queries/application-quick-filters'
import { serverQuickFilters } from './queries/server-quick-filters'
import { routeQuickFilters } from './queries/routes-quick-filters'
import { atoAttacks } from './queries/ato-attacks'
import {
  applicationAggregations,
  customApplicationAggregations
} from './queries/application-aggregations'
import { organizationApplicationTags } from './queries/organization-application-tags'
import { organizationLibraryTags } from './queries/organization-library-tags'
import { agentFeatures } from './queries/agent-features'
import { servers } from './queries/servers'
import { server } from './queries/server'
import { serverAggregations } from './queries/server-aggregations'
import { organizationServerTags } from './queries/organization-server-tags'
import { vulnerabilityQuickFilters } from './queries/vulnerability-quick-filters'
import {
  sessionMetadataAggregations,
  vulnerabilityAggregations
} from './queries/vulnerability-aggregations'
import { vulnerabilitySeveritySnapshots } from './queries/vulnerability-severity-snapshots'
import { vulnerabilityDiscoverySnapshots } from './queries/vulnerability-discovery-snapshots'
import { organizationVulnerabilityTags } from './queries/organization-vulnerability-tags'
import { organizationApplicationsSettings } from './queries/application-settings'
import { compliancePolicies } from './queries/compliance-policies'
import { remediationPolicies } from './queries/remediation-policies'
import { customMetadataFields } from './queries/custom-metadata-fields'
import { sessionMetadataAppFields } from './queries/session-metadata-app-fields'
import { currentFeatureFlags } from './queries/feature-flags'
import {
  adminApprovalEvaluateTraces,
  adminApprovalEvaluateTracesByFilters
} from './queries/admin-approval-evaluate-traces'
import { jobStatus } from './queries/job-status'
import { customMetadataSettings } from './queries/custom-metadata-settings'
import { tutorials } from './queries/tutorials'
import { attackEvent } from './queries/attack-event'
import { libraries } from './queries/libraries'
import { library } from './queries/library'
import { libraryAggregations } from './queries/library-aggregations'
import { libraryQuickFilters } from './queries/library-quick-filters'
import { sourceNames } from './queries/source-names'
import { sourceName } from './queries/source-name'
import { attackEventAggregations } from './queries/attack-event-aggregations'
import { attackEvents } from './queries/attack-events'
import { attackEventQuickFilters } from './queries/attack-event-quick-filters'
import { organizationDetails } from './queries/organization-details'
import { applicationArchitectureComponents } from './queries/application-architecture-components'
import { architectureAssociatedApplications } from './queries/architecture-associated-applications'
import {
  architectureAssociatedApplicationAggregations,
  customArchitectureAssociatedApplicationAggregations
} from './queries/architecture-associated-application-aggregations'
import { applicationNames } from './queries/application-names'
import { applicationArchitecture } from './queries/application-architecture'
import { sensitiveDataPolicySummaries } from './queries/sensitive-data-policy-summaries'
import { sensitiveDataPolicy } from './queries/sensitive-data-policy'
import { stigTemplate } from './queries/stig-template'
import { approvalWorkflowSettings } from './queries/approval-workflow-settings'
import { vulnerabilityPolicies } from './queries/vulnerability-policies'
import { vulnerabilityPolicy } from './queries/vulnerability-policy'
import { applicationLiveArchitecture } from './queries/application-live-architecture'
import { baseAssessRules } from './queries/base-assess-rules'
import { protectRules } from './queries/protect-rules'
import { teamserverPreference } from './queries/teamserver-preference'
import { applicationVulnerabilityTags } from './queries/application-vulnerability-tags'
import { applicationServerTags } from './queries/application-server-tags'
import { reportingStatus } from './queries/reporting-status'
import { reportingInfo } from './queries/reporting-info'
import { attackEventNotes } from './queries/attack-event-notes'
import { emailDomains } from './queries/email-domains'
import { organizationDigestSettings } from './queries/organization-digest-settings'
import { userDigestSettings } from './queries/user-digest-settings'
import { libraryUsage } from './queries/library-usage-data'
import { sensitiveDataMaskingSettings } from './queries/sensitive-data-masking-settings'
import { libraryUsageItem } from './queries/library-usage-item'
import { substatusAlias } from './queries/vulnerability-substatus-alias'
import { serverlessAccessToken } from './queries/serverless-access-token'
import { routeCoverage } from './queries/route-coverage'
import { route } from './queries/route'
import { vulnerabilitiesAndSinkGroups } from './queries/vulnerabilities-and-sink-groups'
import { vulnerabilityOrSinkGroup } from './queries/vulnerability-or-sink-group'

import { routeAggregations } from './queries/route-coverage-aggregations'
import { diagnosticCollection } from './queries/diagnostic-collection'

export const query = new GraphQLObjectType({
  name: 'Query',
  fields: () => ({
    viewer,
    currentFeatureFlags,
    organization,
    agentFeatures,
    application,
    applications,
    applicationGrade,
    applicationModules,
    applicationQuickFilters,
    atoAttacks,
    applicationAggregations,
    customApplicationAggregations,
    organizationApplicationTags,
    organizationLibraryTags,
    servers,
    server,
    diagnosticCollection,
    serverAggregations,
    organizationServerTags,
    serverQuickFilters,
    routeQuickFilters,
    vulnerabilitiesAndSinkGroups,
    vulnerabilityOrSinkGroup,
    vulnerabilityQuickFilters,
    vulnerabilityAggregations,
    sessionMetadataAggregations,
    vulnerabilitySeveritySnapshots,
    vulnerabilityDiscoverySnapshots,
    organizationVulnerabilityTags,
    organizationApplicationsSettings,
    compliancePolicies,
    remediationPolicies,
    adminApprovalEvaluateTraces,
    adminApprovalEvaluateTracesByFilters,
    jobStatus,
    customMetadataFields,
    sessionMetadataAppFields,
    customMetadataSettings,
    tutorials,
    attackEvent,
    libraries,
    library,
    libraryAggregations,
    libraryQuickFilters,
    sourceNames,
    sourceName,
    attackEventAggregations,
    attackEvents,
    attackEventNotes,
    attackEventQuickFilters,
    organizationDetails,
    applicationArchitectureComponents,
    architectureAssociatedApplications,
    architectureAssociatedApplicationAggregations,
    customArchitectureAssociatedApplicationAggregations,
    applicationNames,
    applicationArchitecture,
    sensitiveDataPolicySummaries,
    sensitiveDataPolicy,
    stigTemplate,
    approvalWorkflowSettings,
    vulnerabilityPolicies,
    vulnerabilityPolicy,
    applicationLiveArchitecture,
    baseAssessRules,
    protectRules,
    teamserverPreference,
    applicationVulnerabilityTags,
    applicationServerTags,
    reportingStatus,
    reportingInfo,
    emailDomains,
    organizationDigestSettings,
    sensitiveDataMaskingSettings,
    userDigestSettings,
    libraryUsage,
    libraryUsageItem,
    substatusAlias,
    serverlessAccessToken,
    routeCoverage,
    route,
    routeAggregations
  })
})
